import { TaskTable } from './TaskTable';
import { TableSkeleton } from './TableSkeleton';
import { StateMessage } from './StateMessage';
import { useTasksContext } from '../context/TasksContext';

export const ListView = () => {
  const {
    tasks,
    isLoading,
    tasksError,
    retryTasks,
    handleSortChange,
    filters,
    currentPage,
    totalPages,
    handlePageChange,
    newTasksCount,
  } = useTasksContext();

  if (isLoading) {
    return <TableSkeleton rowCount={12} />;
  }

  if (tasksError) {
    return (
      <StateMessage
        variant="error"
        title="Não foi possível carregar as tarefas"
        description="A busca falhou. Verifique sua conexão e tente de novo."
        onRetry={retryTasks}
      />
    );
  }

  if (tasks.length === 0) {
    return (
      <StateMessage
        variant="empty"
        title="Nenhuma tarefa encontrada"
        description="Nenhuma tarefa corresponde aos filtros selecionados. Tente ampliar o período ou limpar os filtros."
      />
    );
  }

  return (
    <TaskTable
      tasks={tasks}
      onSortChange={handleSortChange}
      parentSortOrder={filters.sortOrder || 'desc'}
      currentPage={currentPage}
      totalPages={totalPages}
      onPageChange={handlePageChange}
      newTasksCount={newTasksCount}
    />
  );
};
